// Kleiner Wrapper um fetch(), der automatisch den Authorization-Header setzt.
// Praktisch fuer bestehende Komponenten wie DataUploader, DataVisualizer, Planner,
// die bisher ohne Auth-Header an die API-Endpoints gehen.
//
// Verwendung in einer Komponente:
//
//   const { token } = useAuth();
//   const apiFetch = createAuthFetch(token);
//   const res = await apiFetch("/api/data");
//
export function createAuthFetch(token: string | null) {
  return (url: string, options: RequestInit = {}) => {
    const headers = new Headers(options.headers);
    if (token) headers.set("Authorization", `Bearer ${token}`);
    return fetch(url, { ...options, headers });
  };
}
